import { useMemo } from "react";
import { Card } from "../../../components/Card";
import { LottieLoading } from "../../../components/Loading/LottieLoading";
import { useApp } from "../../../services/app-context";
import { PerformanceView } from "../../praxis-call/components/PerformanceView";
import { CallInsight } from "../../praxis-call/components/report-tabs/Performance";

export function TeamInsights({ data = [], loading }: { data: any[], loading?: boolean }) {
  const { tenantProfile } = useApp();
  const metric_exclusions = tenantProfile?.metric_exclusions || {};
  const dashboardsMetricExclusions = useMemo(() => {
    const newObj: any = {};
    Object.keys(metric_exclusions?.dashboards || {}).forEach((key) => {
      newObj[key.toLowerCase()] = metric_exclusions?.dashboards?.[key];
    });
    return newObj;
  }, [metric_exclusions]);

  const filteredData = data.filter((item) => dashboardsMetricExclusions[item.key]?.show !== false);
  return (
    <Card>
      <div className="text-xl text-text-primary mb-4">Overall Team Insights</div>

      {loading ? <LottieLoading className="!w-full !h-[100px]" /> : (
        <div className="grid  xl:grid-cols-2 grid-cols-1 gap-6">
          {filteredData.map((metric, index) => (
            <PerformanceView
              key={metric.key ?? metric.name ?? index}
              title={metric.name}
              value={Number(Number(metric.value).toFixed(0))}
            />
          ))}

        </div>
      )}
    </Card>
  );
}
